import Vue from 'vue'

/**
 * @author jorge nuñez lópez <>
 *
 * Create a new transfer 
 * @param newTransfer tranfer object
 * @return {object}
 */

function transferTransformer({
  comment, quantity, destinationWarehouse,
  warehouseSupplyId
})  {
  return {
    comment,
    quantity,
    to_iwarehouse: destinationWarehouse,
    iwarehouse_supply: warehouseSupplyId
  }
}
export default (newTransfer) => {
  const payload = transferTransformer(newTransfer)
  return Vue.$http.post(`iwarehouse/transfer-material/`, payload)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/sendTransfer.js